import React from "react";


import SimpleBanner from "../../components/common/SimpleBanner";
import BlogGrid from "../../components/User/Blog/BlogGrid";
import BlogCTA from "../../components/User/Blog/BlogCTA";

const Blog = () => {
  return (
    <div className="bg-black font-saira text-white">
  

      <SimpleBanner
        title="Blogs"
        subheading="Home / Blogs"
      />
      <BlogGrid />

      {/* <BlogCTA /> */}

     
    </div>
  );
};

export default Blog;